import adminApi from 'services/admin/adminApi';

export const FETCH_ADMIN_SALES_AGENTS_BEGIN = 'FETCH_ADMIN_SALES_AGENTS_BEGIN';
export const FETCH_ADMIN_SALES_AGENTS_SUCCESS = 'FETCH_ADMIN_SALES_AGENTS_SUCCESS';
export const FETCH_ADMIN_SALES_AGENTS_FAILURE = 'FETCH_ADMIN_SALES_AGENTS_FAILURE';

export const CLEAR_SALES_AGENTS = 'CLEAR_SALES_AGENTS';
export const CLEAR_SALES_AGENTS_NOTIFICATION = 'CLEAR_SALES_AGENTS_NOTIFICATION';


export const FETCH_ADMIN_SALES_AGENTS_BY_ID_BEGIN = 'FETCH_ADMIN_SALES_AGENTS_BY_ID_BEGIN';
export const FETCH_ADMIN_SALES_AGENTS_BY_ID_SUCCESS = 'FETCH_ADMIN_SALES_AGENTS_BY_ID_SUCCESS';
export const FETCH_ADMIN_SALES_AGENTS_BY_ID_FAILURE = 'FETCH_ADMIN_SALES_AGENTS_BY_ID_FAILURE';


export function fetchSalesAgents(params) {
  return dispatch => {
    dispatch(fetchSalesAgentsBegin());
    return adminApi.fetchSalesAgents(params)
      .then(json => {
        dispatch(fetchSalesAgentsSuccess(json));
        return json;
      })
      .catch(error => {
        dispatch(fetchSalesAgentsFailure(error));

      });
  };
}

//Get Invoices details

export function fetchSalesAgentById(id) {
  return dispatch => {
    dispatch(fetchSalesAgentByIDBegin());
    return adminApi.fetchSalesAgentsById(id)
      .then(json => {
        dispatch(fetchSalesAgentByIDSuccess(json.data));

        return json;
      })
      .catch(error => {
        console.log(error);
        dispatch(fetchSalesAgentByIDFailure(error));
      });
  };


}


export const fetchSalesAgentsBegin = () => ({
  type: FETCH_ADMIN_SALES_AGENTS_BEGIN,
});

export const fetchSalesAgentsSuccess = json => ({
  type: FETCH_ADMIN_SALES_AGENTS_SUCCESS,
  payload: {
    salesAgents: json.data.sales_agents,
    pagination: json.data.pagination,
    filters: json.data.filters,
  },
});

export const fetchSalesAgentsFailure = error => ({
  type: FETCH_ADMIN_SALES_AGENTS_FAILURE,
  payload: { error: (error.response) ? error.response.data : 'Something went wrong. Please try again' },
});

export const clearSalesAgents = () => ({
  type: CLEAR_SALES_AGENTS,
});
export const clearSalesAgentsNotifications = () => ({
  type: CLEAR_SALES_AGENTS_NOTIFICATION,
});


export const fetchSalesAgentByIDBegin = () => ({
  type: FETCH_ADMIN_SALES_AGENTS_BY_ID_BEGIN,
});

export const fetchSalesAgentByIDSuccess = salesAgentsDetails => ({
  type: FETCH_ADMIN_SALES_AGENTS_BY_ID_SUCCESS,
  payload: { salesAgentsDetails: salesAgentsDetails },
});

export const fetchSalesAgentByIDFailure = error => ({
  type: FETCH_ADMIN_SALES_AGENTS_BY_ID_FAILURE,
  payload: { error: (error.response) ? error.response.data : 'Something went wrong. Please try again' },
});
